import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SocialPost.css';
import {SocialPostUserHeader} from "./SocialPostUserHeader";
import {SocialPostPageHeader} from "./SocialPostPageHeader";
import {SocialVideo} from "./SocialVideo";
import {SocialText} from "./SocialText";
import {SocialPostReaction} from "./SocialPostReaction";
import {SocialGroupName} from "./SocialGroupName";
import {PostFeeling} from "./PostFeeling";
import { NewSocialPostForm } from "./NewSocialPostForm";
import { TaskPreview } from "./TaskPreview";
import { ImageViewer } from "./ImageViewer";
import { Waypoint } from 'react-waypoint';
import { FaEllipsisH, FaPen, FaTrashAlt, FaLink, FaExclamationTriangle } from 'react-icons/fa';
import { OverlayTrigger, Tooltip, Dropdown } from 'reactstrap';

const SocialPost = ({ minimum = false, post, postId, page }) => {
  const [the_post, setPost] = useState(null);
  const [error, setError] = useState('');
  const [userPost, setUserPost] = useState(false);
  const [pagePost, setPagePost] = useState(false);
  const [groupPost, setGroupPost] = useState(false);
  const [isShared, setIsShared] = useState(false);
  const [underMessage, setUnderMessage] = useState("");
  const [canDelete, setCanDelete] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [deleted, setDeleted] = useState(false);  
  const [showOptions, setShowOptions] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [reportSuccess, setReportSuccess] = useState(false);
  
  // États pour l'affichage d'image en plein écran
  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState({ src: '', alt: '' });
  
  const optionsRef = useRef(null);
  const [user, setUser] = useState(null);

  const openInDefaultBrowser = (url) => {
    if (window.cordova && window.cordova.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, '_system');
    } else {
      // fallback pour navigateur classique
      window.open(url, '_blank');
    }
  };

  // Fonction utilitaire pour valider et extraire l'hostname d'une URL
  const getUrlHostname = (urlString) => {
    try {
      const url = new URL(urlString);
      return url.hostname;
    } catch (error) {
      console.warn('URL invalide:', urlString, error);
      // Retourner une version tronquée de l'URL si elle est invalide
      return urlString.length > 50 ? urlString.substring(0, 50) + '...' : urlString;
    }
  };

  // Fonction utilitaire pour valider une URL
  const isValidUrl = (urlString) => {
    try {
      new URL(urlString);
      return true;
    } catch (error) {
      return false;
    }
  };

  // Fermer le menu d'options si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("liberium-token");
    if (token !== null) {
        const mine = localStorage.getItem("myself");
        if (mine !== null) {
            try {
                const userData = JSON.parse(mine);
                setUser(userData);
            } catch (e) {
                console.error("Erreur lors de la lecture des données utilisateur:", e);
            }
        }
    }
  }, []);

  const onDelete = async () => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce post ?")) {
      try {
        const response = await sdk.models.post.deletePost({post_id: the_post.id});
        console.log("Delete response:", response);
        setDeleted(true);
      } catch (error) {
        console.error("Erreur lors de la suppression du post:", error);
        setError("Erreur lors de la suppression du post. Veuillez réessayer.");
      }
    }
  };

  const onEdit = () => {
    setShowEditModal(true);
    setShowOptions(false);
  };

  const onShare = () => {
    // Cette fonction est gérée dans SocialPostReaction
    setShowOptions(false);
  };

  const onCopyLink = () => {
    const postUrl = `https://peupleqc.com/post/${the_post.id}`;
    
    navigator.clipboard.writeText(postUrl)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      })
      .catch(err => {
        console.error('Erreur lors de la copie du lien:', err);
      });
    
    setShowOptions(false);
  };

  const onReport = () => {
    // Fonctionnalité pour signaler un post
    // À implémenter selon les besoins
    setReportSuccess(true);
    setTimeout(() => setReportSuccess(false), 2000);
    setShowOptions(false);
  };

  const savePostClick = () => {
    sdk.models.PostClick.saveClick({
        post_id: the_post.id
    });
  };

  // Fonction pour ouvrir le visualiseur d'image
  const openImageViewer = (src, alt) => {
    setCurrentImage({ src, alt });
    setViewerOpen(true);
  };

  // Fonction pour fermer le visualiseur d'image
  const closeImageViewer = () => {
    setViewerOpen(false);
  };

  const updatePost = (post) => {
    setUnderMessage(post.il_y_a);

    if (post.error) {
      // Rien à faire ici en cas d'erreur
    } else if (post.user_id !== null && post.user_id > 0) {
      if (post.page_id !== null && post.page_id > 0) {
        setPagePost(true);
      } else if (post.group_id !== null && post.group_id > 0) {
        setGroupPost(true);
        setUnderMessage(
          <>
            a publié dans{" "}
            <SocialGroupName group_id={post.group_id} />
          </>
        );
      } else {
        setUserPost(true);
      }

      if (post.postType === "profile_picture") {
        setUnderMessage(<>a changé sa photo de profil</>);
      }
    } else if (post.page_id !== null) {
      setPagePost(true);
    }

    if (post.shared_from !== null && post.shared_from > 0) {
      setIsShared(true);
      setUnderMessage("a republié ce post");
    }
  };

  const handlePostUpdate = (updatedPost) => {
    // Mettre à jour le post après modification
    setPost(updatedPost);
    setShowEditModal(false);
  };

  // Gestionnaire de clic sécurisé pour les liens
  const handleLinkClick = () => {
    if (!the_post.postLink) return;
    
    // Vérifier si l'URL est valide avant de l'ouvrir
    if (isValidUrl(the_post.postLink)) {
      savePostClick();
      openInDefaultBrowser(the_post.postLink);
    } else {
      console.error('URL invalide, impossible d\'ouvrir le lien:', the_post.postLink);
      // Optionnel: afficher un message d'erreur à l'utilisateur
      alert('Ce lien semble invalide et ne peut pas être ouvert.');
    }
  };

  useEffect(() => {
    if (post) {
      setPost(post);
      updatePost(post);
    }
  }, [post]);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await sdk.models.post.getPost({id: postId});
        if (response) {
          const hasLiked = await sdk.models.PostsLike.hasLiked({post_id: postId});
          response.hasLiked = hasLiked.hasLiked;
          setPost(response);
          updatePost(response);
        } else {
          setError('Post non trouvé');
        }
      } catch (err) {
        console.error("Erreur lors de la récupération du post:", err);
        setError('Erreur lors de la récupération du post');
      }
    };

    if (postId) {
      fetchPost();
    }
  }, [postId]);

  useEffect(() => {
    if (!user || !the_post) return;
    
    // Vérifier si l'utilisateur peut supprimer le post
    if (the_post.user_id === user.user_id || user.user_id === 2) {
      setCanDelete(true);
    }
    
    // Vérifier si l'utilisateur peut modifier le post (uniquement l'auteur)
    if (the_post.user_id === user.user_id) {
      setCanEdit(true);
    }
  }, [user, the_post]);

  const _handleWaypointLeave = async () => {
    if (user && the_post) {
      try {
        await sdk.models.PostsViews.create({
          user_id: user.user_id,
          post_id: the_post.id,
          time: Math.floor(Date.now() / 1000)
        });
      } catch (error) {
        console.error("Erreur lors de l'enregistrement de la vue:", error);
      }
    }
  };

  if (error) {
    return (
      <div className="post-error">
        <div className="error-icon"><FaExclamationTriangle /></div>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!the_post) {
    return <div className="post-loading">Chargement...</div>;
  }

  if (deleted) return null;

  return (
    <Waypoint onLeave={_handleWaypointLeave}>
      <div className="social-post">      
        <div className="post-container">
          {/* En-tête du post */}
          <div className="post-header-wrapper">
            {userPost && (
              <SocialPostUserHeader
                user_id={the_post.user_id}
                post={the_post}
                underMessage={underMessage}
                canDelete={canDelete}
                onDelete={onDelete}
                canEdit={canEdit}
                onEdit={onEdit}
              />
            )}
            
            {groupPost && (
              <SocialPostUserHeader
                user_id={the_post.user_id}
                post={the_post}
                underMessage={underMessage}
                canDelete={canDelete}
                onDelete={onDelete}
                canEdit={canEdit}
                onEdit={onEdit}
              />
            )}
            
            {pagePost && page && (
              <SocialPostPageHeader
                post={the_post}
                page={page}
                underMessage={underMessage}
                canDelete={canDelete}
                onDelete={onDelete}
                canEdit={canEdit}
                onEdit={onEdit}
              />
            )}
            
            {pagePost && !page && (
              <SocialPostPageHeader
                pageId={the_post.page_id}
                post={the_post}
                underMessage={underMessage}
                canDelete={canDelete}
                onDelete={onDelete}
                canEdit={canEdit}
                onEdit={onEdit}
              />
            )}
          </div>
          
          {/* Contenu du post */}
          <div className="post-content">
            {/* Affichage du sentiment si présent */}
            {the_post.postFeeling && the_post.postFeeling !== 'null' && (
              <PostFeeling feelingData={the_post.postFeeling} />
            )}
            
            {the_post.postText && <SocialText text={the_post.postText} />}

            {/* Affichage de la tâche si task_id est présent */}
            {the_post.task_id && the_post.task_id > 0 && (
              <TaskPreview taskId={the_post.task_id} />
            )}
            
            {/* Affichage des images avec possibilité de cliquer pour zoomer */}
            {the_post.postPhoto && (
              <div className="post-media">
                <img 
                  src={`https://peupleqc.com/s/peupleqc-upload/${the_post.postPhoto}`} 
                  alt="Post" 
                  className="post-image" 
                  loading="lazy"
                  onClick={() => openImageViewer(`https://peupleqc.com/s/peupleqc-upload/${the_post.postPhoto}`, "Image du post")}
                  style={{ cursor: 'zoom-in' }}
                />
              </div>
            )}
            
            {/* Affichage des vidéos */}
            {the_post.postFile && (the_post.postFile.endsWith('.m3u8') || the_post.postFile.endsWith('.mp4')) && (
              <div className="post-media">
                <SocialVideo
                  poster={the_post.postFileThumb ? `https://peupleqc.com/s/peupleqc-upload/${the_post.postFileThumb}` : undefined}
                  url={the_post.postFile}
                  className="post-video"
                />
              </div>
            )}
            
            {/* Affichage des autres fichiers avec possibilité de cliquer pour zoomer */}
            {the_post.postFile && !the_post.postFile.endsWith('.mp4') && !the_post.postFile.endsWith('.m3u8') && (
              <div className="post-media">
                <img 
                  src={`https://peupleqc.com/s/peupleqc-upload/${the_post.postFile}`} 
                  alt="Post" 
                  className="post-image" 
                  loading="lazy"
                  onClick={() => openImageViewer(`https://peupleqc.com/s/peupleqc-upload/${the_post.postFile}`, "Fichier du post")}
                  style={{ cursor: 'zoom-in' }}
                />
              </div>
            )}
            
            {/* Aperçu des liens avec gestion d'erreur pour les URLs invalides */}
            {the_post.postLink && (
              <div 
                onClick={handleLinkClick}
                className="post-link"
                style={{ cursor: 'pointer' }}
              >
                {the_post.postLinkImage && (
                  <div className="link-image-container">
                    <img 
                      src={`https://peupleqc.com/s/peupleqc-upload/${the_post.postLinkImage}`} 
                      alt={the_post.postLinkTitle || "Lien partagé"} 
                      className="link-image"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="link-content-container">
                  {the_post.postLinkTitle && (
                    <h4 className="link-title">{the_post.postLinkTitle}</h4>
                  )}
                  {the_post.postLinkContent && (
                    <p className="link-description">{the_post.postLinkContent}</p>
                  )}
                  <span className="link-url">{getUrlHostname(the_post.postLink)}</span>
                </div>
              </div>
            )}
          </div>
          
          {/* Affichage des posts partagés */}
          {isShared && (
            <div className="shared-post-container">
              <SocialPost
                postId={the_post.shared_from}
                minimum={true}
              />
            </div>
          )}
          
          {/* Section commentaires et réactions */}
          {/* Modification: toujours afficher les interactions, même pour les posts partagés */}
          {!minimum && (
            <div className="post-interaction-section">
              {user && the_post && (
                <SocialPostReaction
                  post={the_post}
                />
              )}
            </div>
          )}
        </div>
        
        {/* Modal d'édition du post */}
        {showEditModal && (
          <NewSocialPostForm
            user={user}
            editMode={true}
            postToEdit={the_post}
            isOpen={showEditModal}
            toggleModal={() => setShowEditModal(false)}
            setNewPost={handlePostUpdate}
          />
        )}
        
        {/* Visualiseur d'image en plein écran */}
        <ImageViewer 
          src={currentImage.src}
          alt={currentImage.alt}
          isOpen={viewerOpen}
          onClose={closeImageViewer}
          downloadFilename={the_post?.postPhoto || the_post?.postFile || "image"}
        />
      </div>
    </Waypoint>
  );
};

export { SocialPost };